<script lang="ts">
    import {getLocalization} from 'src/core';
    import type {PalmknihyAudioLoanability, PalmknihyLoanability, PalmknihyPdfLoanability} from 'src/typings';
    import OpenOnExternalLoanProviderWebsiteLink from './OpenOnExternalLoanProviderWebsiteLink.svelte';

    export let capability: PalmknihyLoanability | PalmknihyAudioLoanability | PalmknihyPdfLoanability;

    const localize = getLocalization();
</script>

<OpenOnExternalLoanProviderWebsiteLink {capability}>
    {localize(/* @kp-localization loan.palmknihy.ShowOnPalmknihy */ 'loan.palmknihy.ShowOnPalmknihy')}
</OpenOnExternalLoanProviderWebsiteLink>